
import { TypeNotification } from "@/enums/TypeNotification";
import { computed, defineComponent } from "vue";
import { useStore } from "../store";

export default defineComponent({
  name: "Notificacoes",
  data() {
    return {
      contexto: {
        [TypeNotification.SUCESSO]: "is-success",
        [TypeNotification.ATENÇÃO]: "is-warning",
        [TypeNotification.FALHA]: "is-danger",
      },
    };
  },

  setup() {
    const store = useStore();
    return {
      notificacoes: computed(() => store.state.notificacoes),
    };
  },
});
